var required = function (value) {
    return !!value;
};

export { required };
